var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/translation-editor.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { Language } from "@adornis/translation-core/languages.js";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import { TranslationEntry, TranslationTableRow } from "../db/translation-entry.js";
var languages = [Language.GERMAN, Language.ENGLISH];
var TranslationEditor = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.translationData = new RXController(
      this,
      TranslationEntry.subscribeTranslationTable(languages)(TranslationTableRow.allFields)
    );
  }
  render() {
    return html`
      <x-grid columns="max-content ${new Array(languages.length).fill("1fr").join(" ")}" space="md">
        ${this.translationData.value?.map(
      (row) => html`
              <x-flex space="xs" center>
                ${row.keyPath.length > 1 ? html` <x-text tone="subtle"> ${row.keyPath.slice(0, -1).join(".")} </x-text> ` : nothing}
                <x-text bold> ${row.keyPath.slice(-1)[0]} </x-text>
              </x-flex>
              ${languages.map((language) => {
        const pair = row.get(language);
        return html`
                  <x-flex center>
                    ${pair ? html`
                          <editable-x-text
                            ${css({
          border: pair?.overrideByUser ? `1px solid ${this.colors.tone.error}` : "1px solid transparent",
          borderRadius: this.sizes.borderRadius
        })}
                            .text=${pair.translation}
                            @value-picked=${(e) => XDialog.guard(
          () => TranslationEntry.setTranslation(language, row.keyPath, e.detail.value)()
        )}
                          >
                          </editable-x-text>
                        ` : html`
                          <x-button mode="text" icon="add" tone="warning"> hinzufügen </x-button>
                          ${row.isOverridden ? html`
                                <x-button
                                  mode="text"
                                  icon="refresh"
                                  tone="error"
                                  @click=${() => XDialog.guard(() => TranslationEntry.resetTranslation(row.keyPath)())}
                                >
                                  zurücksetzen
                                </x-button>
                              ` : nothing}
                        `}
                  </x-flex>
                `;
      })}
            `
    )}
      </x-grid>
    `;
  }
};
__decorateClass([
  state()
], TranslationEditor.prototype, "translationData", 2);
TranslationEditor = __decorateClass([
  customElement("translation-editor")
], TranslationEditor);
var EditableXText = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.text = "";
    this.changed = false;
  }
  render() {
    return html`
      <x-flex
        contenteditable="true"
        ${acss({
      position: "relative",
      cursor: "pointer",
      borderRadius: this.sizes.borderRadius,
      "&:hover": { background: this.colors.neutral.shade(100) }
    })}
        @input=${() => this.changed = true}
      >
        ${this.changed ? nothing : html`
              <x-icon ${css({ position: "absolute", right: this.spacing.xxs, top: this.spacing.xxs })}> edit </x-icon>
            `}
        ${this.changed ? html`
              <x-icon
                tone="success"
                ${css({ position: "absolute", right: this.spacing.xxs, top: this.spacing.xxs })}
                @click=${() => {
      const value = (this.shadowRoot?.querySelector("#content")).innerText;
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value } }));
      this.changed = false;
    }}
              >
                save
              </x-icon>
            ` : nothing}
        <x-text id="content" ${css({ minHeight: "1rem", padding: this.spacing.xs })}> ${this.text} </x-text>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], EditableXText.prototype, "text", 2);
__decorateClass([
  state()
], EditableXText.prototype, "changed", 2);
EditableXText = __decorateClass([
  customElement("editable-x-text")
], EditableXText);
export {
  EditableXText,
  TranslationEditor
};
